import { grid } from '@app/components/package-customize/customize-sheet-item/sheet/utils';

export default {
  nameDesc: '2 - 5x7',
  imageCount: 2,
  displayGroup: 'DG_5X7',
  calc: (height) => grid(1, 2, height)
};
